import { render, staticRenderFns } from "./WeUnderstand.vue?vue&type=template&id=329a815c&scoped=true&"
import script from "./WeUnderstand.vue?vue&type=script&lang=js&"
export * from "./WeUnderstand.vue?vue&type=script&lang=js&"
import style0 from "./WeUnderstand.vue?vue&type=style&index=0&id=329a815c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a815c",
  null
  
)

export default component.exports